import React from 'react';

import { getAuth0AuthorizationParams, getConfig } from '@/lib/config';
import { AppState, Auth0Provider } from '@auth0/auth0-react';

interface Auth0ProviderWithRouterProps {
  children: React.ReactNode;
}

const RETURN_TO_KEY = 'auth0_return_to';

export function Auth0ProviderWithRouter({
  children,
}: Auth0ProviderWithRouterProps) {
  const config = getConfig();
  const authorizationParams = getAuth0AuthorizationParams();

  const handleRedirectCallback = React.useCallback((appState?: AppState) => {
    // Store returnTo for the redirect page to handle after post-registration
    let returnTo = appState?.returnTo;

    if (!returnTo) {
      returnTo = localStorage.getItem(RETURN_TO_KEY) || '/';
    }

    // Keep returnTo in localStorage — redirect page will read and clean it up
    localStorage.setItem(RETURN_TO_KEY, returnTo);
  }, []);

  return (
    <Auth0Provider
      domain={config.auth0.domain}
      clientId={config.auth0.clientId}
      authorizationParams={{
        ...authorizationParams,
        redirect_uri: config.auth0.redirectUri,
      }}
      onRedirectCallback={handleRedirectCallback}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
}

// Export the key for use in other components
export { RETURN_TO_KEY };
